import React, { Component } from 'react';
import TableRef from '../util/TableRef';
import cssSummarize from '../css/module/summarizeInline.css';
import flex from '../css/module/flex.css';
import SummarizeGroupbys from './SummarizeGroupbys';
import SummarizeMetrics from './SummarizeMetrics';

class SummarizeInline extends Component {
  constructor(props) {
    super(props);
    this.getTableOrInsightName = this.getTableOrInsightName.bind(this);
  }

  // alias = alias, showType = bool, justTable = bool
  getTableOrInsightName(alias, showType, justTable) {
    const { aliases } = this.props;
    const object = aliases[alias];
    const type = !object
      ? ''
      : object && object instanceof TableRef
      ? 'table'
      : 'saved query';
    const name = object ? object.name() : 'custom';

    if (justTable) {
      return name;
    }
    return (
      <span>
        {name}
        {showType ? <small className="faint"> {type}</small> : ''}
      </span>
    );
  }

  render() {
    return (
      <div>
        <div className={`${flex.alignItemsCenter} ${flex.wrap}`}>
          <div className={cssSummarize.summarizeSection}>
            <SummarizeMetrics
              metrics={this.props.state.metrics}
              columns={this.props.columns}
              aliases={this.props.aliases}
              currentLayer={this.props.currentLayer}
              getTableOrInsightName={this.getTableOrInsightName}
              setState={this.props.setState}
            />
          </div>
          <div
            className={cssSummarize.summarizeSection}
            style={{ marginRight: '0px' }}
          >
            <SummarizeGroupbys
              metricsCount={this.props.state.metrics.length}
              groupBys={this.props.state.groupBys}
              columns={this.props.columns}
              extraColumns={this.props.state.extraColumns}
              getTableOrInsightName={this.getTableOrInsightName}
              setState={this.props.setState}
              aliases={this.props.aliases}
            />
          </div>
        </div>
      </div>
    );
  }
}

export default SummarizeInline;
